import type { Sound } from "common/sound";
import { Howl } from "howler";
class AudioPlayer {
    private sound: Howl;

    constructor(name: Sound) {
        this.sound = new Howl({ src: `/media/sound/${name}.mp3` });
    }

    public play() {
        this.sound.play();
    }
}

export default AudioPlayer;
